import { Box, Typography } from '@mui/material'
import useFetchCaseNotes from '../../../hooks/useFetchCaseNotes'
import { FC } from 'react'
import { format } from 'date-fns'

interface ProformaNotesProps {
  caseId: string
}

const ProformaNotes: FC<ProformaNotesProps> = ({ caseId }) => {
  const { notes } = useFetchCaseNotes({ caseId, noteTypes: ['billing'] })

  if (!notes?.length) return null

  return (
    <Box mt={2} mb={2}>
      <Typography fontWeight={600} fontSize="12px" mb={0.5}>
        Proforma Notes
      </Typography>

      <Box>
        {notes.map(note => (
          <Typography key={note?.id} fontSize="10px">
            {note?.description} - {note?.createdAt && format(new Date(Number(note.createdAt)), 'MM/dd/yyyy')}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}

export default ProformaNotes
